import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.css']
})
export class ProductViewComponent implements OnInit {
    prodId;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadMenu() {
        if (!!this.prodId) {
            this.menu = (await this.datatask.Post(215, { prod_id: this.prodId }))[0];
        }
    }

    public async goToFunc(state: any) {
        if (!this.menu) return;

        switch (state) {
            case 'stock':
                const response = (await this.datatask.Post(455, {
                    functionname: 'stock',
                    barcode: this.menu.prod_id
                }))[0];

                this.stateService?.go(response?.webpagename, response?.parms);
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    prod_id: string;
    prod_name: string;
    url_picture: string;
    show_custom_key_information1: string;
    custom_key_information1: string;
    show_custom_key_information2: string;
    custom_key_information2: string;
    show_custom_key_information3: string;
    custom_key_information3: string;
    show_setting: string;
}
